import { useNavigate } from "react-router-dom";

export const PayrollRoutesComponent = () => {
	const navigate = useNavigate();
	const ArrayData = [
		// {
		// 	label: "Pending...",
		// 	menuHeaderLabel: true,
		// },
		{
			label: "Payroll",
			command: () => {
				navigate("/payroll");
			},
		},
		// {
		// 	label: "CRA Credit",
		// 	command: () => {
		// 		navigate("/");
		// 	},
		// },
		// {
		// 	label: "RQ",
		// 	command: () => {
		// 		navigate("/");
		// 	},
		// },

	];

	return {
		PayrollRoutes: ArrayData,
	};
};
